import { atom, selector } from 'recoil';
import { EntryDto } from '@/model/entry.dto';

export const entryListRecoil = atom<EntryDto[] | null>({
  key: 'entryListRecoil',
  default: null,
});

export const entryListLengthRecoil = atom<number | undefined>({
  key: 'entryListLengthRecoil',
  default: 0,
});

export const entryDetailListRecoil = atom<EntryDto[] | null>({
  key: 'entryDetailListRecoil',
  default: null,
});

export const entryDetailListLengthRecoil = atom<number | undefined>({
  key: 'entryDetailListLengthRecoil',
  default: 0,
});

export const entryCertiIdRecoil = atom<string | null>({
  key: 'entryCertiIdRecoil',
  default: '',
});

export const entryNameRecoil = atom<string | null>({
  key: 'entryNameRecoil',
  default: '',
});

export const entryPhoneRecoil = atom<string | null>({
  key: 'entryPhoneRecoil',
  default: '',
});

export const entryPlaceIdRecoil = atom<string | null>({
  key: 'entryPlaceIdRecoil',
  default: '',
});

export const entryStartDateRecoil = atom<string | null>({
  key: 'entryStartDateRecoil',
  default: '',
});

export const entryEndDateRecoil = atom<string | null>({
  key: 'entryEndDateRecoil',
  default: '',
});

// export const entryModifyNumRecoil = atom<number | null>({
//   key: 'entryModifyNumRecoil',
//   default: null,
// });

// export const entryModifyRecoil = selector<EntryDto | null>({
//   key: 'entryModifyRecoil',
//   get: ({ get }) => {
//     const list = get(entryListRecoil);
//     const modifyNum = get(entryModifyNumRecoil);
//     if (list && modifyNum !== null) {
//       return list.find((item) => item.id === modifyNum) || null;
//     } else {
//       return null;
//     }
//   },
// });
